import { Component, OnInit } from '@angular/core';
import { RouterLink }          from '@angular/router';
import {environment} from "../../../environments/environment";

@Component({
    selector: 'key-art',
    templateUrl: './key-art.component.html'
})
export class KeyArtComponent implements OnInit {
    env = environment;


    constructor() { }

    ngOnInit() {
    }

}
